// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-page {
  padding: 20px;
}
.audit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.audit-header h2 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
}
.audit-filters {
  display: flex;
  align-items: center;
  gap: 8px;
}
.audit-filters .form-control {
  max-width: 160px;
}
.audit-loading {
  text-align: center;
  padding: 40px;
  color: #999;
}
.audit-table-wrap {
  overflow-x: auto;
}
.audit-table {
  font-size: 0.82rem;
}
.audit-table th {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.68rem;
  letter-spacing: 0.04em;
  color: #666;
  border-bottom: 2px solid #ddd;
  white-space: nowrap;
}
.audit-table td {
  vertical-align: middle;
  white-space: nowrap;
}
.audit-row-flagged {
  background: #fef2f2 !important;
}
.audit-row-audited {
  opacity: 0.7;
}
.audit-link {
  color: #005ff0;
  cursor: pointer;
  font-weight: 600;
  text-decoration: underline;
}
.audit-delta-warn {
  color: #ea580c;
  font-weight: 700;
}
.audit-delta-danger {
  color: #dc2626;
  font-weight: 700;
}
.audit-fraud-badge {
  font-size: 1rem;
}
.audit-audited-badge {
  font-size: 1rem;
}
.audit-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 0;
}
.audit-page-info {
  font-size: 0.82rem;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/app/audit-module/audit-landing/audit-landing.component.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AAJA;EAOI,SAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;AADA;EAKkB,gBAAA;AADlB;AAIA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AAFF;AAKA;EACE,gBAAA;AAHF;AAMA;EACE,kBAAA;AAJF;AAGA;EAII,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;AAJJ;AANA;EAcI,sBAAA;EACA,mBAAA;AALJ;AASA;EACE,8BAAA;AAPF;AAUA;EACE,YAAA;AARF;AAWA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AATF;AAYA;EACE,cAAA;EACA,gBAAA;AAVF;AAaA;EACE,cAAA;EACA,gBAAA;AAXF;AAcA;EACE,eAAA;AAZF;AAeA;EACE,eAAA;AAbF;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AAdF;AAiBA;EACE,kBAAA;EACA,WAAA;AAfF","sourcesContent":[".audit-page {\n  padding: 20px;\n}\n\n.audit-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n\n  h2 {\n    margin: 0;\n    font-size: 1.3rem;\n    font-weight: 700;\n  }\n}\n\n.audit-filters {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  .form-control { max-width: 160px; }\n}\n\n.audit-loading {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n}\n\n.audit-table-wrap {\n  overflow-x: auto;\n}\n\n.audit-table {\n  font-size: 0.82rem;\n\n  th {\n    font-weight: 700;\n    text-transform: uppercase;\n    font-size: 0.68rem;\n    letter-spacing: 0.04em;\n    color: #666;\n    border-bottom: 2px solid #ddd;\n    white-space: nowrap;\n  }\n\n  td {\n    vertical-align: middle;\n    white-space: nowrap;\n  }\n}\n\n.audit-row-flagged {\n  background: #fef2f2 !important;\n}\n\n.audit-row-audited {\n  opacity: 0.7;\n}\n\n.audit-link {\n  color: #005ff0;\n  cursor: pointer;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.audit-delta-warn {\n  color: #ea580c;\n  font-weight: 700;\n}\n\n.audit-delta-danger {\n  color: #dc2626;\n  font-weight: 700;\n}\n\n.audit-fraud-badge {\n  font-size: 1rem;\n}\n\n.audit-audited-badge {\n  font-size: 1rem;\n}\n\n.audit-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 12px 0;\n}\n\n.audit-page-info {\n  font-size: 0.82rem;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
